import { observe } from 'mobx';
import { load } from './util';
import { KEYCODES } from './util/keycodes';

$(document).on('blur', '[data-fastentry-item]', function() {
  const $item = $(this);
  const itemId = $item.val();

  if (itemId) {
    $.stores.fastEntry.fetchItemInfo(
      $item.closest('[data-fastentry-form]').attr('data-action-info'),
      itemId,
    );
  }
});

$(document).on('input', '[data-fastentry-item]', () => {
  $.stores.fastEntry.clear();
});

$(document).on('keydown', '[data-fastentry-item]', function(event) {
  if (event.which === KEYCODES.ENTER) {
    event.preventDefault();
    event.stopPropagation();
    $(this).blur();
    $(this).closest('[data-fastentry-form]').find('[data-fastentry-quantity]').focus();
  }
});

$(document).on('submit', '[data-fastentry-form]', function(event) {
  if ($(this).is('[data-cart-group-select]')) {
    return;
  }

  event.preventDefault();
  const app = $(this).attr('data-fastentry-form');
  const isReel = $(this).attr('data-reels');
  const hasContract = $(this).attr('data-contracts');

  if (isReel || hasContract) {
    const $qty = $(this).find('input[name="quantity"]');
    const data = {};
    data.app = app;
    if ($qty && $qty.val() !== '') {
      data.quantity = $qty.val();
    }

    $.ajax({
      method: 'GET',
      url: isReel || hasContract,
      data,
    }).done((resp) => {
      const element = $(resp).appendTo($('body'));
      element.foundation().foundation('open');
    });
  } else {
    load(this, $.stores[app].post($(this).attr('action'), $(this).serializeArray()));
    $.stores.fastEntry.clear(true);
    $('[data-fastentry-item]').val('').get(0).focus();
  }
});

observe($.stores.fastEntry, 'unit', () => {
  $('[data-fastentry-form]').attr('data-unit', $.stores.fastEntry.unit ? $.stores.fastEntry.unit.iso : '');
});

observe($.stores.fastEntry, 'selectUrl', () => {
  $('[data-fastentry-form]').attr(
    'data-reels',
    $.stores.fastEntry.isReel && $.stores.fastEntry.selectUrl ? $.stores.fastEntry.selectUrl : '',
  );
  $('[data-fastentry-form]').attr(
    'data-contracts',
    $.stores.fastEntry.hasContracts && $.stores.fastEntry.selectUrl ? $.stores.fastEntry.selectUrl : '',
  );
});
